import { render, staticRenderFns } from "./metrics_score_chart.vue?vue&type=template&id=c070eb0a&scoped=true&"
import script from "./metrics_score_chart.vue?vue&type=script&lang=js&"
export * from "./metrics_score_chart.vue?vue&type=script&lang=js&"
import style0 from "./metrics_score_chart.vue?vue&type=style&index=0&id=c070eb0a&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c070eb0a",
  null
  
)

export default component.exports